import dayjs from "dayjs";

export const DATE_FORMAT = "DD/MM/YYYY";
export const dateFormat = (date) => {
  return date ? dayjs(date).format("YYYY/MM/DD") : null;
};

export const todayDate = () => {
  return dayjs().format(DATE_FORMAT);
};
export const INDIA_STATE_LIST = [
  {
    name: "Andhra Pradesh",
    code: "AP",
  },
  {
    name: "Arunachal Pradesh",
    code: "AR",
  },
  {
    name: "Assam",
    code: "AS",
  },
  {
    name: "Bihar",
    code: "BR",
  },
  {
    name: "Chhattisgarh",
    code: "CG",
  },
  {
    name: "Goa",
    code: "GA",
  },
  {
    name: "Gujarat",
    code: "GJ",
  },
  {
    name: "Haryana",
    code: "HR",
  },
  {
    name: "Himachal Pradesh",
    code: "HP",
  },
  {
    name: "Jammu and Kashmir",
    code: "JK",
  },
  {
    name: "Jharkhand",
    code: "JH",
  },
  {
    name: "Karnataka",
    code: "KA",
  },
  {
    name: "Kerala",
    code: "KL",
  },
  {
    name: "Madhya Pradesh",
    code: "MP",
  },
  {
    name: "Maharashtra",
    code: "MH",
  },
  {
    name: "Manipur",
    code: "MN",
  },
  {
    name: "Meghalaya",
    code: "ML",
  },
  {
    name: "Mizoram",
    code: "MZ",
  },
  {
    name: "Nagaland",
    code: "NL",
  },
  {
    name: "Odisha",
    code: "OD",
  },
  {
    name: "Punjab",
    code: "PB",
  },
  {
    name: "Rajasthan",
    code: "RJ",
  },
  {
    name: "Sikkim",
    code: "SK",
  },
  {
    name: "Tamil Nadu",
    code: "TN",
  },
  {
    name: "Telangana",
    code: "TS",
  },
  {
    name: "Tripura",
    code: "TR",
  },
  {
    name: "Uttarakhand",
    code: "UK",
  },
  {
    name: "Uttar Pradesh",
    code: "UP",
  },
  {
    name: "West Bengal",
    code: "WB",
  },
  {
    name: "Andaman and Nicobar Islands",
    code: "AN",
  },
  {
    name: "Chandigarh",
    code: "CH",
  },
  {
    name: "Dadra and Nagar Haveli",
    code: "DN",
  },
  {
    name: "Daman and Diu",
    code: "DD",
  },
  {
    name: "Delhi",
    code: "DL",
  },
  {
    name: "Lakshadweep",
    code: "LD",
  },
  {
    name: "Puducherry",
    code: "PY",
  },
];
